(function () {
  class WinController {
    constructor() {
      this._batcher = undefined;
      this._winlineAnimator = undefined;
      this._symbolAnimator = undefined;
      this._symbolAnimatorLow = undefined;
      this._active = false;
      this._skipped = false;
    }

    initialise(json) {
      this._batcher = resourceManager.getSharedPlugin(json.batcher_normal);
      this._symbolAnimator = json.symbolAnimator ? resourceManager.get(json.symbolAnimator) : undefined;
      this._symbolAnimatorLow = json.symbolAnimatorLow ? resourceManager.get(json.symbolAnimatorLow) : undefined;
      this._winlineAnimator = json.winlineAnimator ? resourceManager.getSharedPlugin(json.winlineAnimator) : undefined;

      // const symbolsConfig = resourceManager.getConfiguration().symbols;
      // this.symbolIdToWinSoundMap = {
      //   [symbolsConfig['Ace'].ID]: 'snakeWin',
      //   [symbolsConfig['Hogtail'].ID]: 'dogWin',
      //   [symbolsConfig['Disco'].ID]: 'jaguarWin',
      //   [symbolsConfig['Logo'].ID]: 'montezumaWin',
      // };
      // this.lowWinSounds = ['lowWin1', 'lowWin2', 'lowWin3'];
    }

    startAnimations(winData, celebrationThreshold, slotMachine, completeCallback) {
      let self = this;
      self._active = true;
      let canCelebrate = winData.totalLineWinnings > celebrationThreshold;
      let sequenceData = this._batcher.batch(winData, celebrationThreshold);
      this._skipped = false;

      let currentSequence = 0;
      let playNextSequence = function (i) {
        // sound part moved to gameController
        // if (canCelebrate) {
        //   musicManager.changeMusicVolume(musicManager.loweredMusicVolume);

        //   // hunters moon hack, only play symbol win soun don the all batch
        //   let bestSymbolWin = -1;
        //   if (currentSequence === 0) {
        //     for (let j = 0; j < sequenceData[i].length; ++j) {
        //       if (sequenceData[i][j].winId > bestSymbolWin) {
        //         bestSymbolWin = sequenceData[i][j].winId;
        //       }
        //     }
        //   } else {
        //     bestSymbolWin = 0;
        //   }

        //   const bestSymbolWinSound = self.symbolIdToWinSoundMap[bestSymbolWin];
        //   if (bestSymbolWinSound != null) {
        //     soundManager.play(self.symbolIdToWinSoundMap[bestSymbolWin]);
        //   } else {
        //     // Play the win sound here based on win amount
        //     const winnings = winData.totalLineWinnings;
        //     const stake = gameController.getCurrentModeStake();
        //     if (winnings <= stake) {
        //       soundManager.play('lowerThanStakeWin');
        //     } else {
        //       const randIndex = Math.floor(Math.random() * self.lowWinSounds.length);
        //       soundManager.play(self.lowWinSounds[randIndex]);
        //     }
        //   }
        // }

        let linesToPlay = [];

        for (let j = 0; j < sequenceData[i].length; ++j) {
          linesToPlay.push(sequenceData[i][j].winline);
        }

        let uniqueArray = linesToPlay.filter(function (item, pos) {
          return linesToPlay.indexOf(item) == pos;
        });

        let winlines = [];
        for (let j = 0; j < uniqueArray.length; ++j) {
          winlines.push(winData.winningLines[uniqueArray[j]]);
        }

        // late hunters moon hack
        let loop = currentSequence === 0;
        let showWinCounter = currentSequence > 0;

        //self._winlineAnimator.playAnimations(winlines,function(){},showWinCounter);
        let animatorToUse = self._symbolAnimator;
        if (!canCelebrate) {
          animatorToUse = self._symbolAnimatorLow;
        }
        if (animatorToUse) {
          animatorToUse.animateSymbols(
            sequenceData[i],
            slotMachine,
            true,
            false,
            function () {
              ++currentSequence;
              if (currentSequence >= sequenceData.length || self._skipped) {
                self._active = false;
                completeCallback();
              } else {
                if (self._skipped) {
                  self._active = false;
                  completeCallback();
                } else {
                  playNextSequence(currentSequence);
                }
              }
            },
            function () {}
          );
        }
      };
      playNextSequence(currentSequence);
    }

    isActive() {
      return this._active;
    }

    skipAnimations() {
      if (this.isActive()) {
        this._skipped = true;
        this._symbolAnimator.skip();
        this._symbolAnimatorLow.skip();
        if (this._winlineAnimator) this._winlineAnimator.skipAnimation();
      }
    }
  }

  let createWinController = function () {
    return new WinController();
  };

  resourceManager.registerController('WinControllerAllAtOnce', createWinController);
})();
